import isotipoImg from "~/assets/academia-isotipo.png";
import { cn } from "~/lib/utils";

type AcademiaLoaderProps = {
  label?: string;
  compact?: boolean;
  className?: string;
};

/**
 * Loading oficial de AcademIA.
 *
 * No usa ruedas ni círculos heredados del template. La marca respira mientras una señal roja
 * recorre una línea de lectura: el mismo lenguaje de recorrido/progreso que usa la plataforma.
 */
export function AcademiaLoader({
  label = "Cargando",
  compact = false,
  className,
}: AcademiaLoaderProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className={cn(
        "font-landing inline-flex items-center justify-center",
        compact ? "gap-2" : "flex-col gap-3",
        className,
      )}
    >
      <style>{`
        @keyframes academia-loader-mark {
          0%, 100% { transform: translateY(0) scale(1); opacity: .78; }
          50% { transform: translateY(-2px) scale(1.035); opacity: 1; }
        }
        @keyframes academia-loader-signal {
          0% { transform: translateX(-115%); opacity: 0; }
          18%, 76% { opacity: 1; }
          100% { transform: translateX(260%); opacity: 0; }
        }
        @media (prefers-reduced-motion: reduce) {
          .academia-loader-mark,
          .academia-loader-signal { animation: none !important; }
        }
      `}</style>

      <img
        src={isotipoImg}
        alt=""
        aria-hidden="true"
        className={cn(
          "academia-loader-mark shrink-0 object-contain [animation:academia-loader-mark_1.8s_ease-in-out_infinite]",
          compact ? "size-5" : "size-12",
        )}
      />

      <div className={cn("flex flex-col", compact ? "gap-1" : "items-center gap-2")}>
        {!compact && (
          <span className="font-display text-[20px] font-semibold tracking-[-0.02em] text-landing-text">
            Academ<span className="text-landing-red">IA</span>
          </span>
        )}
        <span
          aria-hidden="true"
          className={cn(
            "relative block overflow-hidden rounded-full bg-landing-stone-200",
            compact ? "h-[2px] w-8" : "h-[3px] w-24",
          )}
        >
          <span className="academia-loader-signal absolute inset-y-0 left-0 w-2/5 rounded-full bg-landing-red [animation:academia-loader-signal_1.25s_ease-in-out_infinite]" />
        </span>
      </div>

      <span className="sr-only">{label}</span>
    </div>
  );
}
